export default __webpack_public_path__ + "static/media/slide1.a608cb9a.png";